module.exports = __webpack_public_path__ + "static/media/php.37d3a14e.png";